export const URL_PARAM_PAGE = 'page';
export const URL_PARAM_TYPE = 'type';
export const URL_PARAM_MAP_POSITION = 'mapPosition';